import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-login',
  templateUrl: './breadcrumb-login.component.html',
  styleUrls: ['./breadcrumb-login.component.scss']
})
export class BreadcrumbLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
